<template>
  <modal-template :id="id" :name="name" :showModal="showModal" v-on:hide-modal="close()">
    <template slot="modalContent">
      <div id="subheader">
        <div>{{ output.description }}</div>
        <v-data-table :items="output.data" hide-actions class="elevation-5">
          <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
          <template slot="headers" slot-scope="props">
            <tr>
              <th class="text-xs-left" v-for="h in output.headers" :key="h">{{ h }}</th>
              <th style="width: 70px;"></th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left" v-for="h in output.headers" :key="h">
                <v-text-field :append-icon="checkIfBoolean(props.item[h])" 
                placeholder="Insert value" v-model="props.item[h]" hide-details></v-text-field>
              </td>
              <td><v-btn icon @click="removeLine(props.item)"><v-icon color="pink">delete</v-icon></v-btn></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <v-btn @click="addLine" color="info">New Line</v-btn>
    </template>
  </modal-template>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import ModalTemplate from '@/components/Workspace/Methods/ModalTemplate'
export default {
  components: {
    ModalTemplate
  },
  data: () => ({
    showModal: false
  }),
  props: {
    id: String,
    name: String,
    output: Object,
  },
  methods: {
    clone(object) {
      return JSON.parse(JSON.stringify(object));
    },
    setPropertyFromInputFile(mod) {
      if(typeof mod.value !== 'undefined' && mod.value.length > 0) {
        this.output.data = this.clone(mod.value);
        this.output.headers = mod.headers ? mod.headers : Object.keys(this.output.data[0]);
      } else {
        this.output.data = [];
        this.output.headers = [];
      }
    },
    addLine() {
      this.output.data.push({});
    },
    removeLine(line) {
      var index = this.output.data.indexOf(line);
      if(index > -1)
        this.output.data.splice(index, 1);
    },
    checkIfBoolean(value) {
      if(['true', true].includes(value)) return 'check_box';
      else if(['false', false].includes(value)) return 'check_box_outline_blank';
      else return undefined;
    },
    close () {
      this.showModal = false;
    }
  },
  mounted: function () {
    EventBus.$on('show-modal-'+this.id, mod => {   // this is a special case of the data modal, if its connected to another
      EventBus.$emit('check-connection', this.id); // module you want to show its modal instead -> must communicate with the
    });                                            // workspace to validate this
    EventBus.$on('show-modal-data-'+this.id, mod => {
      this.showModal = true;
    });
    EventBus.$on('update-module-'+this.id, mod => {
      this.setPropertyFromInputFile(mod);
    });
  }
}
</script>

<style scoped>
  #subheader {
    margin: 20px;
    font-size: 20px;
    line-height: 1.5;
  }
  * {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px
  }
  table.v-table thead th {
    background-color: #f2f2f2;
    max-width: 150px;
    white-space: initial;
    word-wrap: break-word;
    color: #333333 !important;
    font-size: 13px;
    font-weight: bold;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
    border-bottom: 1px solid LightGray;
  }
  table.v-table tbody td {
    font-family: 'Roboto Mono', sans-serif !important;
    word-wrap: break-word;
    font-size: 12px;
    font-weight: normal;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
  }
  .v-input {
    font-size: 12px;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .column-wrap {
    width: 1px;
    white-space: nowrap;
  }

</style>


// WEBPACK FOOTER //
// src/components/Workspace/Methods/DataModal.vue